import { RootState } from 'store/types';
import { createSelector } from 'reselect';
import { userExternalTermsAndConditionsSelector } from 'store/profile/selectors';
import { tempTermsAndConditionsSelector } from 'store/global/selectors';
import { TermAcceptance } from 'mobile/src/models/consumer';

export const searchStateSelector = (state: RootState) => state.providerSearch.search;

export const searchFetchingSelector = createSelector(searchStateSelector, ps => ps.isFetching);
export const searchErrorSelector = createSelector(searchStateSelector, ps => ps.error);
export const searchDataSelector = createSelector(searchStateSelector, ps => ps.data);
export const searchCountSelector = createSelector(searchStateSelector, ps => ps.count);
export const searchTermsShownSelector = createSelector(searchStateSelector, ps => ps.termsShown);

export const searchRawSelector = createSelector(searchStateSelector, ps => ps.raw);

export const searchRawDataSelector = createSelector(searchRawSelector, raw => raw.data);
export const searchRawTotalSelector = createSelector(searchRawSelector, raw => raw.total);
export const searchRawCountSelector = createSelector(searchRawSelector, raw => raw.count);

export const searchTermsAndConditionsAccepted = createSelector(
  userExternalTermsAndConditionsSelector,
  tempTermsAndConditionsSelector,
  (external: TermAcceptance[], temp) => {
    const acceptedExternal = external?.some?.(term => term.type === 'PROVIDER_SEARCH');
    const acceptedTemp = temp?.['PROVIDER_SEARCH'];

    return acceptedExternal || acceptedTemp;
  }
);

export const searchFilterOptionsSelector = createSelector(
  searchStateSelector,
  ps => ps.filterOptions
);
